// import React, { useState, useEffect } from "react";
// import NewsItem from "./NewsItem";
// import Spinner from "./Spinner";
// import PropTypes from "prop-types";
// import WelcomeGreet from "./WelcomeGreet";
// import InfiniteScroll from "react-infinite-scroll-component";
// import ScrollButton from "./ScrollButton";
// // import ScrollToTop from "react-scroll-to-top";

// const News = (props) => {
//     const [articles, setArticles] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [page, setPage] = useState(1);
//     const [totalResults, setTotalResults] = useState(0);

//     const capitalizeFirstLetter = (string) => {
//         return string.charAt(0).toUpperCase() + string.slice(1);
//     };

//     const updateNews = async () => {
//         props.setProgress(10);
//         const url = `https://newsapi.org/v2/top-headlines?country=${props.country}&category=${props.category}&apiKey=${props.apiKey}&page=${page}&pageSize=${props.pageSize}`;
//         setLoading(true);
//         props.setProgress(40);
//         let data = await fetch(url);
//         props.setProgress(70);
//         let parsedData = await data.json();
//         setArticles(parsedData.articles);
//         setTotalResults(parsedData.totalResults);
//         setLoading(false);
//         props.setProgress(100);
//     };

//     // const updateNews = async () => {
//     //     props.setProgress(10);
//     //     // const url1 = `https://newsapi.org/v2/top-headlines?country=${props.country}&category=${props.category}&apiKey=${props.apiKey}&page=${page}&pageSize=${props.pageSize}`;
//     //     const url = `https://newsi-api.p.rapidapi.com/api/category?category=${props.category}&language=en&country=${props.country}&page=${page}&limit=${props.pageSize}`
//     //     const options = {
//     //         method: 'GET',
//     //         headers: {
//     //             'X-RapidAPI-Key': '624bf2748bmsh91fc4b6bf09b8aap1836edjsn7e16bf60c44d',
//     //             'X-RapidAPI-Host': 'newsi-api.p.rapidapi.com'
//     //         }
//     //     };
//     //     setLoading(true);
//     //     props.setProgress(40);
//     //     let data = await fetch(url, options);
//     //     props.setProgress(70);
//     //     let parsedData = await data.json();
//     //     setArticles(parsedData.articles);
//     //     setTotalResults(parsedData.totalResults);
//     //     setLoading(false);
//     //     props.setProgress(100);
//     // };

//     const setTitle = () => {
//         if (props.tabTitle === "original") {
//             document.title =
//                 "NewsyDoozy - Unleash the Buzz! Stay Informed with NewsyDoozy.";
//         } else {
//             document.title = `${capitalizeFirstLetter(props.category)} - NewsyDoozy`;
//         }
//     }

//     useEffect(() => {
//         updateNews();
//         setTitle();
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, []);

//     const fetchMoreData = async () => {
//         const url = `https://newsapi.org/v2/top-headlines?country=${props.country
//             }&category=${props.category}&apiKey=${props.apiKey}&page=${page + 1
//             }&pageSize=${props.pageSize}`;
//         setPage(page + 1);
//         setLoading(true);
//         let data = await fetch(url);
//         let parsedData = await data.json();
//         setArticles(articles.concat(parsedData.articles));
//         setTotalResults(parsedData.totalResults);
//         setLoading(false);
//     };

//     return (
//         <>
//             <div className="container">
//                 <WelcomeGreet />
//                 {loading && <Spinner />}
//                 <InfiniteScroll
//                     dataLength={articles.length}
//                     next={fetchMoreData}
//                     hasMore={articles.length !== totalResults}
//                     loader={loading && <Spinner />}
//                 >
//                     <div className="container">
//                         <div className="row">
//                             {articles.map((element, index) => {
//                                 return (
//                                     <div className="col-md-4" key={index}>
//                                         <NewsItem
//                                             title={element.title ? element.title.slice(0, 100) : ""}
//                                             description={
//                                                 element.description
//                                                     ? element.description.slice(0, 130)
//                                                     : ""
//                                             }
//                                             imageUrl={element.urlToImage}
//                                             newsUrl={element.url}
//                                             mode={props.mode}
//                                             author={element.author}
//                                             date={element.publishedAt}
//                                             source={element.source.name}
//                                         />
//                                     </div>
//                                 );
//                             })}
//                         </div>
//                     </div>
//                 </InfiniteScroll>
//                 {/* <div> */}
//                     {/* <ScrollToTop smooth style={{border: "1px solid black"}}/> */}
//                     {/* This I have done this using a react package called react */}
//                 {/* </div> */}
//                 <ScrollButton mode={props.mode}/> {/* For this I have taked reference from https://www.geeksforgeeks.org/how-to-create-a-scroll-to-top-button-in-react-js/*/}
//             </div>
//         </>
//     );
// };

// News.defaultProps = {
//     country: "in",
//     pageSize: 15,
//     category: "general",
// };
// News.propTypes = {
//     country: PropTypes.string.isRequired,
//     pageSize: PropTypes.number.isRequired,
//     category: PropTypes.string.isRequired,
// };

// export default News;






import React, { useState, useEffect } from "react";
import NewsItem from "./NewsItem";
import Spinner from "./Spinner";
import PropTypes from "prop-types";
import WelcomeGreet from "./WelcomeGreet";
import InfiniteScroll from "react-infinite-scroll-component";
import ScrollButton from "./ScrollButton";
// import ScrollToTop from "react-scroll-to-top";

const News = (props) => {
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    // const [totalResults, setTotalResults] = useState(0);

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    const updateNews = async () => {
        props.setProgress(10);
        // const url1 = `https://newsapi.org/v2/top-headlines?country=${props.country}&category=${props.category}&apiKey=${props.apiKey}&page=${page}&pageSize=${props.pageSize}`;
        const url = `https://newsi-api.p.rapidapi.com/api/category?category=${props.category}&language=${props.selectedLanguage}&country=${props.country}&page=${page}&limit=${props.pageSize}`
        const options = {
            method: 'GET',
            headers: {
                'X-RapidAPI-Key': '624bf2748bmsh91fc4b6bf09b8aap1836edjsn7e16bf60c44d',
                'X-RapidAPI-Host': 'newsi-api.p.rapidapi.com'
            }
        };
        setLoading(true);
        props.setProgress(40);
        let data = await fetch(url, options);
        props.setProgress(70);
        let parsedData = await data.json();
        // console.log(parsedData);
        setArticles(parsedData);
        // setTotalResults(parsedData.totalResults);
        setLoading(false);
        props.setProgress(100);
    };

    const setTitle = () => {
        if (props.tabTitle === "original") {
            document.title =
                "NewsyDoozy - Unleash the Buzz! Stay Informed with NewsyDoozy.";
        } else {
            document.title = `${capitalizeFirstLetter(props.category)} - NewsyDoozy`;
        }
    }

    useEffect(() => {
        updateNews();
        setTitle();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.selectedLanguage]);

    const fetchMoreData = async () => {
        // const url1 = `https://newsapi.org/v2/top-headlines?country=${props.country
        //     }&category=${props.category}&apiKey=${props.apiKey}&page=${page + 1
        //     }&pageSize=${props.pageSize}`;
        const url = `https://newsi-api.p.rapidapi.com/api/category?category=${props.category}&language=${props.selectedLanguage}&country=${props.country}&page=${page + 1}&limit=${props.pageSize}`
        const options = {
            method: 'GET',
            headers: {
                'X-RapidAPI-Key': '624bf2748bmsh91fc4b6bf09b8aap1836edjsn7e16bf60c44d',
                'X-RapidAPI-Host': 'newsi-api.p.rapidapi.com'
            }
        };
        setPage(page + 1);
        setLoading(true);
        let data = await fetch(url, options);
        let parsedData = await data.json();
        setArticles(articles.concat(parsedData));
        // setTotalResults(parsedData.totalResults);
        setLoading(false);
    };

    return (
        <>
            <div className="container">
                <WelcomeGreet />
                {loading && <Spinner />}
                <InfiniteScroll
                    dataLength={articles.length}
                    next={fetchMoreData}
                    hasMore={articles.length > 0}
                    loader={loading && <Spinner />}
                >
                    <div className="container">
                        <div className="row">
                            {articles.map((element, index) => {
                                return (
                                    <div className="col-md-4" key={index}>
                                        <NewsItem
                                            title={element.title ? element.title.slice(0, 100) : ""}
                                            description={
                                                element.body
                                                    ? element.body.slice(0, 130)
                                                    : ""
                                            }
                                            imageUrl={element.image}
                                            newsUrl={element.link}
                                            mode={props.mode}
                                            author={element.sourceName}
                                            date={element.publishedAt}
                                            source={element.shortLink}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </InfiniteScroll>
                {/* <div> */}
                {/* <ScrollToTop smooth style={{border: "1px solid black"}}/> */}
                {/* This I have done this using a react package called react */}
                {/* </div> */}
                <ScrollButton mode={props.mode} /> {/* For this I have taked reference from https://www.geeksforgeeks.org/how-to-create-a-scroll-to-top-button-in-react-js/*/}
            </div>
        </>
    );
};

News.defaultProps = {
    country: "in",
    pageSize: 15,
    category: "general",
};
News.propTypes = {
    country: PropTypes.string.isRequired,
    pageSize: PropTypes.number.isRequired,
    category: PropTypes.string.isRequired,
};

export default News;
